import styles from './QuickActionsSection.module.css';
import QuickActionCard from '../../components/QuickActionCard/QuickActionCard';

import { FaUserPlus, FaEye } from 'react-icons/fa';
import { HiOutlineDocumentPlus } from 'react-icons/hi2';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useNavigate } from 'react-router';

const QuickActionsSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Add new Student',
      icon: <FaUserPlus />,
      onclick: () => dispatch(openModal('addStudent')),
    },
    {
      label: 'Add New Staff',
      icon: <FaUserPlus />,
      onclick: () => dispatch(openModal('addStaff')),
    },
    {
      label: 'Add Room',
      icon: <HiOutlineDocumentPlus />,
      onclick: () => dispatch(openModal('addroom')),
    },
    { label: 'View Exam Results', icon: <FaEye /> },
    {
      label: 'AddTemplete',
      icon: <HiOutlineDocumentPlus />,
      onclick: () => dispatch(openModal('addTemplete')),
    },
    {
      label: 'Post Activities',
      icon: <HiOutlineDocumentPlus />,
      onclick: () => navigate('/communication/activities'),
    },
    { label: 'Post Activities', icon: <HiOutlineDocumentPlus /> },
    { label: 'Post Activities', icon: <HiOutlineDocumentPlus /> },
    { label: 'Post Activities', icon: <HiOutlineDocumentPlus /> },
    { label: 'Post Activities', icon: <HiOutlineDocumentPlus /> },
    { label: 'Post Activities', icon: <HiOutlineDocumentPlus /> },
    { label: 'Post Activities', icon: <HiOutlineDocumentPlus /> },
  ];

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>Quick Actions</h3>
      <div className={styles.cardGrid}>
        {actions.map((action, index) => (
          <QuickActionCard
            key={index}
            icon={action.icon}
            label={action.label}
            onclick={action.onclick}
          />
        ))}
      </div>
    </div>
  );
};

export default QuickActionsSection;
